import { useLang } from "../i18n/LanguageContext";

export default function Sports() {
  const { t } = useLang();
  const s = t.sports;

  return (
    <section
      id="sports"
      data-testid="sports-section"
      className="relative py-24 md:py-40 border-b border-[#1a1a1a]"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        {/* Section header */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16 md:mb-24">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-4 mb-6">
              <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#ff4500]">
                {s.label}
              </span>
              <span className="h-[1px] w-16 bg-[#262626]" />
            </div>
            <h2
              data-testid="sports-heading"
              className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight"
            >
              {s.headingA}{" "}
              <span className="italic text-[#ff4500]">{s.headingB}</span>
            </h2>
          </div>
        </div>

        {/* Body — left copy + right areas of practice */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-6">
            <p className="text-neutral-300 text-lg md:text-xl leading-relaxed max-w-xl">
              {s.lead}
            </p>
          </div>

          <div className="lg:col-span-5 lg:col-start-8">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-500 mb-6">
              {s.areasLabel}
            </div>
            <ul className="divide-y divide-[#1a1a1a] border-y border-[#1a1a1a]">
              {s.areas.map((area, i) => (
                <li
                  key={i}
                  data-testid={`sports-area-${i}`}
                  className="flex items-start gap-4 py-4 group"
                >
                  <span className="font-mono text-[10px] text-[#ff4500] pt-2 tabular-nums">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="font-serif text-xl md:text-2xl font-light tracking-tight text-white group-hover:text-[#ff4500] transition-colors duration-300">
                    {area}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Strategic Thinking sub-block */}
        <div className="mt-24 md:mt-32 pt-16 md:pt-20 border-t border-[#1a1a1a]">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
            <div className="lg:col-span-4">
              <div className="flex items-center gap-4 mb-6">
                <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#ff4500]">
                  {s.thinkingLabel}
                </span>
              </div>
              <h3
                data-testid="sports-thinking-title"
                className="font-serif text-3xl md:text-4xl lg:text-5xl font-light leading-[1.05] tracking-tight italic"
              >
                {s.thinkingTitle}
              </h3>
            </div>
            <div className="lg:col-span-7 lg:col-start-6">
              <p className="text-neutral-400 text-base md:text-lg leading-relaxed max-w-2xl">
                {s.thinkingBody}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
